

/**
 * Utility function to process a axios error
 *
 * @param axiosError the axios error object
 * @param {(errorMessage: string) => void} errorDisplayFunc a function that takes a single string error message parameters
 */
export function axiosErrorHandler(axiosError, errorDisplayFunc) {
    if (axiosError.response) {
        // Unauthorised responses are ignored here.  They are dealt with via an interceptor in index.js
        if (axiosError.response.status !== 401 && axiosError.response.data) {
            const errorResponse = axiosError.response.data;
            if (errorResponse.code && errorResponse.code === "CONCURRENT_MODIFICATION") {
                errorDisplayFunc("Your changes could not be saved and have been discarded. This is because another user has changed the same details.  Please review the changes and reapply your modification.");
            } else if (errorResponse.messages) {
                errorDisplayFunc(errorResponse.messages.join(" and "));
            } else {
                errorDisplayFunc(errorResponse);
            }
        } else if (axiosError.response.status !== 401) {
            errorDisplayFunc("Unknown network error");
        }
    } else if (axiosError.request) {
        errorDisplayFunc("Timeout waiting for server response.");
    } else {
        errorDisplayFunc(axiosError.message);
    }
}
